import { Component, Input, OnInit } from '@angular/core';
import { CurrentEventProvider } from '../../providers/current-event/current-event';
import { MatchmakingProvider } from '../../providers/matchmaking/matchmaking';
import { ToastController } from 'ionic-angular';
/**
 * Generated class for the InterestsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'interests',
  templateUrl: 'interests.html',
})
export class InterestsComponent implements OnInit {
  user: any = {};
  interest: string;
  userInterests: string[] = [];
  currentEvent: any;
  userEventProfile: any = {};

  constructor(
    private currentEventProvider: CurrentEventProvider,
    private matchmakingProvider: MatchmakingProvider,
    private toastCtrl: ToastController
  ) {
    this.currentEvent = this.currentEventProvider.getCurrentEvent();
    this.userEventProfile.interests = [];
  }

  ngOnInit(): void {
    this.loadEventProfile();
  }

  addInterest(): void {
    if (
      /\S/.test(this.interest) ||
      this.userEventProfile.interests.length >= 10
    ) {
      this.userEventProfile.interests.push(this.interest);
    }

    this.interest = '';
  }

  removeInterest(index, interest): void {
    this.userEventProfile.interests.splice(index, 1);
  }

  loadEventProfile() {
    this.matchmakingProvider
      .getUserProfileOnEvent(this.currentEvent.uuid)
      .subscribe(resp => {
        this.userEventProfile = resp;
      });
  }

  updateEventProfile() {
    this.userEventProfile.eventUuid = this.currentEvent.uuid;
    this.matchmakingProvider
      .updateUserProfileOnEvent(this.userEventProfile)
      .subscribe(res => {
        let toast = this.toastCtrl.create({
          message: 'Profile Updated',
          duration: 3000,
          position: 'top',
        });
        toast.present();
      });
  }

}



// WEBPACK FOOTER //
// ./src/components/interests/interests.ts